// Shared write logic for both filter strategies. URLSearchParams and
// Map<string, string> both have get/set/delete, so the strategies only differ
// in how they clone and commit the store (setSearchParams vs setState).
type Store = URLSearchParams | Map<string, string>;

// Set a value (array values are comma-joined), or delete the key when empty.
export const writeValue = (
  store: Store,
  key: string,
  value: string | string[] | undefined,
) => {
  if (value != null && value !== '') {
    store.set(key, Array.isArray(value) ? value.join(',') : value);
  } else {
    store.delete(key);
  }
};

export const writeUpdates = (
  store: Store,
  updates: Record<string, string | string[] | undefined>,
) => {
  Object.entries(updates).forEach(([key, value]) => {
    writeValue(store, key, value);
  });
};
